<div class="container">
	@for (suggest of smartSuggest; track suggest; let i = $index) {
		<div
			class="action-list cursor-pointer"
			(click)="emitSuggestion.emit(suggest.name)"
			[ngClass]="{ disabled: ongoingSuggestionAnalyze(), active: i === index() }"
		>
			<div class="action-icon">
				<mat-icon svgIcon="{{ suggest.icon }}"></mat-icon>{{ suggest.title }}
			</div>
			<span class="action-description">{{ suggest.description }}</span>
		</div>
	}
</div>
